export const uploadProductPackagesModalName: string = 'uploadProductPackagesModalName';
